import { useEffect } from "react";
import { createPortal } from "react-dom";

export default function SideDrawerShell({
  open,
  title,
  subtitle,
  onClose,
  children,
  tabs,
  footer,
  width = "min(760px, 100vw)",
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const drawerNode = (
    <>
      <div className="v2drw-scrim" onClick={onClose} />
      <div className="v2drw" style={{ width }} role="dialog" aria-modal="true">
        <div className="v2drw-head">
          <div className="v2drw-head-main">
            {subtitle ? <div className="v2drw-eyebrow">{subtitle}</div> : null}
            <div className="v2drw-title">{title}</div>
          </div>
          <button className="v2drw-close" type="button" onClick={onClose} aria-label="Close">✕</button>
        </div>
        {tabs ? <div>{tabs}</div> : null}
        <div className="v2drw-body">{children}</div>
        {footer ? <div className="v2drw-foot">{footer}</div> : null}
      </div>
    </>
  );

  if (typeof document !== "undefined" && document.body) {
    return createPortal(drawerNode, document.body);
  }

  return drawerNode;
}
